let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ed2mE")).then(() => parcelRequire('4Bew3'));